import { NFTInterface } from 'models/NFT';
import { INFTDetails, INFTDetailSale } from 'models/NFTDetails';
import { DEMO_WALLET_TRADER, MOCK_BID_TOKEN, pastDate, toTokenAmount } from './constants';
import mockNfts from './nfts';
import mockUsers from './users';

const userName = (wallet: string): string => {
  const user = mockUsers[wallet.toLowerCase()];
  return user?.name || 'Unknown Explorer';
};

const toDetailSale = (
  nft: NFTInterface,
  saleId: number,
  type: 'fixed-price' | 'auction',
  price: number,
): INFTDetailSale => ({
  bidToken: MOCK_BID_TOKEN,
  saleId,
  isBundle: false,
  minPrice: type === 'auction' ? toTokenAmount(price * 0.5) : '0',
  price: toTokenAmount(price),
  status: 'completed',
  startTime: pastDate(30),
  endTime: pastDate(20),
  type,
  buyer: {
    _id: 'demo-buyer',
    name: userName(DEMO_WALLET_TRADER),
    wallet: DEMO_WALLET_TRADER,
  },
  seller: {
    _id: 'demo-seller',
    name: userName(nft.owner),
    wallet: nft.owner,
  },
});

const buildDetail = (nft: NFTInterface): INFTDetails => {
  const liveSale = nft.sale
    ? {
        bidToken: nft.sale.bidToken,
        saleId: nft.sale.saleId,
        isBundle: nft.sale.isBundle,
        minPrice: nft.sale.minPrice,
        price: nft.sale.price,
        status: nft.sale.status,
        startTime: nft.sale.startTime,
        endTime: nft.sale.endTime,
        type: nft.sale.type,
        buyer: {
          _id: 'demo-buyer-live',
          name: userName(DEMO_WALLET_TRADER),
          wallet: nft.sale.buy?.wallet || '',
        },
        seller: {
          _id: 'demo-seller-live',
          name: userName(nft.sale.seller),
          wallet: nft.sale.seller,
        },
      }
    : null;

  const saleHistory: INFTDetailSale[] = [
    toDetailSale(nft, nft.sale?.saleId ? nft.sale.saleId - 50 : 900, 'fixed-price', 1.2),
    toDetailSale(nft, nft.sale?.saleId ? nft.sale.saleId - 40 : 910, 'auction', 2.5),
  ];

  const offers: INFTDetailSale[] = liveSale
    ? []
    : [
        {
          bidToken: MOCK_BID_TOKEN,
          saleId: nft.tokenId + 5000,
          isBundle: false,
          minPrice: '0',
          price: toTokenAmount(1.75),
          status: 'live',
          startTime: pastDate(1),
          endTime: pastDate(-7),
          type: 'offer',
          buyer: {
            _id: 'demo-offer-buyer',
            name: userName(DEMO_WALLET_TRADER),
            wallet: DEMO_WALLET_TRADER,
          },
          seller: {
            _id: 'demo-offer-seller',
            name: userName(nft.owner),
            wallet: nft.owner,
          },
        },
      ];

  return {
    _id: nft._id,
    category: nft.category,
    contract: nft.contract,
    subCategory: nft.subCategory,
    tokenId: nft.tokenId,
    type: nft.type,
    attributes: nft.attributes || {},
    sale: liveSale,
    saleHistory,
    offers,
    metadata: nft.metadata,
    owner: {
      amount: 1,
      wallet: nft.owner,
      name: userName(nft.owner),
    },
    rarity: nft.rarity,
  };
};

const nftDetails: Record<string, INFTDetails> = mockNfts.reduce((acc, nft) => {
  const key = `${nft.contract.toLowerCase()}:${nft.tokenId}`;
  acc[key] = buildDetail(nft);
  return acc;
}, {} as Record<string, INFTDetails>);

export const getMockNftDetail = (contract: string, tokenId: string): INFTDetails | null => {
  const key = `${contract.toLowerCase()}:${tokenId}`;
  return nftDetails[key] || null;
};

export default nftDetails;
